@if (rooms()?.length) {
	<div class="container small-text">
		<div class="row">
			<div class="col-md-1 p-1 fw-bold">Nazwa</div>
			<div class="col-md-3 p-1 fw-bold">Wszystkie</div>
			<div class="col-md-2 p-1 fw-bold">Pozostało</div>
			<div class="col-md-2 p-1 fw-bold">Potwierdzone</div>
			<div class="col-md-1 p-1 fw-bold">Opcje</div>
			<div class="col-md-3 p-1 fw-bold">Akcja</div>
		</div>
		<div class="row">
			<hr class="custom-line" />
		</div>
		@for (room of rooms(); track room.id) {
			<div class="row change-rooms">
				<div class="col-md-1 p-1 fw-bold">{{ room.code }}</div>
				<div class="col-md-3 p-1">
					@if (room.mode === AvailabilityRoomStatus.SAVE) {
						<form [formGroup]="form">
							<mat-form-field appearance="outline" class="small-version">
								<input
									matInput
									type="number"
									name="numberInput"
									formControlName="expectedAvailability"
									min="0"
								/>
								@if (form.controls['expectedAvailability'].errors?.required) {
									<mat-error>Ilość dostępnych pokoi jest wymagana</mat-error>
								}
							</mat-form-field>
						</form>
					} @else {
						{{ room.count }}
					}
				</div>
				<div class="col-md-2 p-1">{{ room.available }}</div>
				<div class="col-md-2 p-1">{{ room.confirmedOffersCount }}</div>
				<div class="col-md-1 p-1">{{ room.optionOffersCount }}</div>
				<div class="col-md-3 p-1 d-flex">
					@if (room.mode === AvailabilityRoomStatus.SAVE) {
						<button
							class="me-2 edit-button"
							mat-raised-button
							(click)="changeRoomAvailability(room)"
							color="warn"
						>
							Zapisz
						</button>
						<button
							class="me-2 cancel-button"
							mat-raised-button
							(click)="cancelRoomAvailability()"
							color="primary"
						>
							Anuluj
						</button>
					} @else {
						<button
							class="me-2 edit-button"
							mat-raised-button
							(click)="room.mode === AvailabilityRoomStatus.EDIT && editRoomAvailability(room)"
							color="primary"
							[disabled]="room.mode === AvailabilityRoomStatus.DISABLED"
						>
							Edytuj
						</button>
					}
				</div>
			</div>
		}
	</div>
} @else {
	<div class="fw-bold">Brak dostępnych pokojów do ustawienia</div>
}
